import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import {
  ApolloClient,
  HttpLink,
  ApolloLink,
  InMemoryCache,
  split,
} from "@apollo/client";

const wsClient = new WebSocketLink({
  uri: process.env.REACT_APP_WS,
  options: { reconnect: true, timeout: 20000, lazy: true },
});

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GL,
});

const splitLink = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  wsClient,
  httpLink
);

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(
    ({ headers = {}, localToken = localStorage.getItem("token") }) => {
      if (localToken) {
        headers["x-token"] = localToken;
      }

      return {
        headers,
      };
    }
  );

  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error("GraphQL error", message);
    });
  }

  if (networkError) {
    alert(`Ошибка сети! ${networkError}.\nОбратитесь к администратору...`);
    window.location.reload();
  }
});

export const cache = new InMemoryCache();
const link = ApolloLink.from([authLink, errorLink, splitLink]);
const client = new ApolloClient({ cache, link });

export default client;
